var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c("plain-text-control", {
        attrs: {
          title: _vm.title,
          required: _vm.required,
          instructionKey: _vm.instructionsKey
        }
      }),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "table tablerow",
          attrs: { "aria-label": _vm.$t(_vm.title) }
        },
        [
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "w-15" }, [
                _c("span", { attrs: { id: "name_label" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("AidApplication.Operation.TargetsAndResults.Name")
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "w-15" }, [
                _c("span", { attrs: { id: "targetgroup_label" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "AidApplication.Operation.TargetsAndResults.TargetGroup"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "w-30" }, [
                _c("span", { attrs: { id: "operationandoutput_label" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        _vm.isBC
                          ? "AidApplication.Operation.TargetsAndResults.OperationAndOutput_BC"
                          : "AidApplication.Operation.TargetsAndResults.OperationAndOutput"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "w-15" }, [
                _c("span", { attrs: { id: "results_label" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "AidApplication.Operation.TargetsAndResults.Results"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "w-15" }, [
                _c("span", { attrs: { id: "indicators_label" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "AidApplication.Operation.TargetsAndResults.Indicators"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "w-5 centered" }, [
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(_vm.$t("Sr_Actions")))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.items, function(item, index) {
              return _c("tr", { key: index, staticClass: "paddingless" }, [
                _c(
                  "td",
                  {
                    class: ["w-15", _vm.isReadOnly ? "disabled-background" : ""]
                  },
                  [
                    _c("text-area-row", {
                      attrs: {
                        id: _vm.getId("targetName", index),
                        rows: 10,
                        maxLength: 500,
                        required: true,
                        canExpand: true,
                        dialogTitle:
                          "AidApplication.Operation.TargetsAndResults.Name",
                        placeholder: "Placeholder.TextArea",
                        ariaLabelId: "name_label",
                        textAreaClasses: "target-row-" + (index + 1)
                      },
                      model: {
                        value: item.name,
                        callback: function($$v) {
                          _vm.$set(item, "name", $$v)
                        },
                        expression: "item.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    class: ["w-15", _vm.isReadOnly ? "disabled-background" : ""]
                  },
                  [
                    _c("text-area-row", {
                      attrs: {
                        id: _vm.getId("targetGroup", index),
                        rows: 10,
                        maxLength: 500,
                        required: true,
                        canExpand: true,
                        dialogTitle:
                          "AidApplication.Operation.TargetsAndResults.TargetGroup",
                        placeholder: "Placeholder.TextArea",
                        ariaLabelId: "targetgroup_label"
                      },
                      model: {
                        value: item.targetGroup,
                        callback: function($$v) {
                          _vm.$set(item, "targetGroup", $$v)
                        },
                        expression: "item.targetGroup"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    class: ["w-30", _vm.isReadOnly ? "disabled-background" : ""]
                  },
                  [
                    _c("text-area-row", {
                      attrs: {
                        id: _vm.getId("targetOperationAndOutput", index),
                        rows: 10,
                        maxLength: 1500,
                        required: true,
                        canExpand: true,
                        dialogTitle:
                          "AidApplication.Operation.TargetsAndResults.OperationAndOutput",
                        placeholder: "Placeholder.TextArea",
                        ariaLabelId: "operationandoutput_label"
                      },
                      model: {
                        value: item.operationAndOutput,
                        callback: function($$v) {
                          _vm.$set(item, "operationAndOutput", $$v)
                        },
                        expression: "item.operationAndOutput"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    class: ["w-15", _vm.isReadOnly ? "disabled-background" : ""]
                  },
                  [
                    _c("text-area-row", {
                      attrs: {
                        id: _vm.getId("targetResults", index),
                        rows: 10,
                        maxLength: 500,
                        required: true,
                        canExpand: true,
                        dialogTitle:
                          "AidApplication.Operation.TargetsAndResults.Results",
                        placeholder: "Placeholder.TextArea",
                        ariaLabelId: "results_label"
                      },
                      model: {
                        value: item.results,
                        callback: function($$v) {
                          _vm.$set(item, "results", $$v)
                        },
                        expression: "item.results"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    class: ["w-15", _vm.isReadOnly ? "disabled-background" : ""]
                  },
                  [
                    _c("text-area-row", {
                      attrs: {
                        id: _vm.getId("targetIndicators", index),
                        rows: 10,
                        maxLength: 500,
                        required: true,
                        canExpand: true,
                        dialogTitle:
                          "AidApplication.Operation.TargetsAndResults.Indicators",
                        placeholder: "Placeholder.TextArea",
                        ariaLabelId: "indicators_label"
                      },
                      model: {
                        value: item.indicators,
                        callback: function($$v) {
                          _vm.$set(item, "indicators", $$v)
                        },
                        expression: "item.indicators"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    class: [
                      "w-5 centered",
                      _vm.isReadOnly ? "disabled-background" : ""
                    ]
                  },
                  [
                    _c("span", [
                      _vm.showDeleteBtn && !_vm.isReadOnly
                        ? _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.top.center",
                                  value: { content: _vm.$t("Btn_DeleteRow") },
                                  expression:
                                    "{ content: $t('Btn_DeleteRow') }",
                                  modifiers: { top: true, center: true }
                                }
                              ],
                              staticClass: "btn btn-link btn-contrast",
                              attrs: {
                                type: "button",
                                "aria-label":
                                  _vm.$t("Btn_DeleteRow") +
                                  (index + 2) +
                                  " -. " +
                                  _vm.$t("Accessibility.ConfirmDeleteRow")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteRow(index)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-trash-alt fa-lg centered"
                              })
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ])
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      !_vm.isReadOnly
        ? _c("div", { staticClass: "mt-3" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: {
                  type: "button",
                  disabled: _vm.isAddNewRowDisabled,
                  "aria-disabled": _vm.isAddNewRowDisabled
                },
                on: {
                  click: function($event) {
                    return _vm.addNewRow()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("AidApplication.Btn_AddTarget")))]
            )
          ])
        : _c("div", { staticClass: "mt-5" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }